import request from '@/utils/request'

// 查询tab页配置列表
export function listTabs(query) {
  return request({
    url: '/config/tabs/list',
    method: 'get',
    params: query
  })
}

// 查询tab页配置详细
export function getTabs(id) {
  return request({
    url: '/config/tabs/' + id,
    method: 'get'
  })
}

// 新增tab页配置
export function addTabs(data) {
  return request({
    url: '/config/tabs',
    method: 'post',
    data: data
  })
}

// 修改tab页配置
export function updateTabs(data) {
  return request({
    url: '/config/tabs',
    method: 'put',
    data: data
  })
}

// 删除tab页配置
export function delTabs(id) {
  return request({
    url: '/config/tabs/' + id,
    method: 'delete'
  })
}
